export class PharmacieAuthDto {

    emailTitulaire: string;
    nomTitulaire: string;
    prenomTitulaire: string;
  
    constructor() {
    }
  
    public static fromJson(json: Object): PharmacieAuthDto {
      return new PharmacieAuthDto()
        .setEmailTitulaire(json['email_titulaire'])
        .setNomTitulaire(json['nom_titulaire'])
        .setPrenomTitulaire(json['prenom_titulaire']);
    }

    setEmailTitulaire(emailTitulaire: string) {
      this.emailTitulaire = emailTitulaire;
      return this;
    }

    setNomTitulaire(nomTitulaire: string) {
      this.nomTitulaire = nomTitulaire;
      return this;
    }

    setPrenomTitulaire(prenomTitulaire: string) {
      this.prenomTitulaire = prenomTitulaire;
      return this;
    }
  
  }
  